
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("list/tasklist-empty-shopping",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcenter class=\"V4 flexauto flexcol\" style=\"max-width: 280px;margin: auto;text-align:center;flex:1\"><img src=\"/images/ic_empty_list_shopping.svg\" width=\"120\" height=\"120\"/><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.emptyshoppingtitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":179},"end":{"line":1,"column":220}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin sub2\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.emptyshopping",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":253},"end":{"line":1,"column":289}}})) != null ? stack1 : "")
    + "</p></flexcenter>";
},"useData":true});
export default TPL;